<template>
  <v-row>
    <v-col cols="12" class="pb-4">
      <v-card class="card--col-toolbar">
        <v-toolbar :dark="$vuetify.theme.dark" color="primary">
          <v-toolbar-title class="textwithbackground--text">
            {{ $t('Регистрация Пользователя ЭП') }}
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-alert
            v-if="isRegistered"
            class="text-center"
            :value="true"
            type="success">
          {{ $t('Уполномоченный представитель зарегистрирован. Для продолжения работы в системе воспользуйтесь расположенным слева меню.') }}
        </v-alert>
        <general-error v-if="!!generalError" />

        <v-progress-linear :active="isLoading" color="loader" indeterminate />
        <v-card-text>
          <v-row v-if="!isLoading" class="ma-4 pb-4">
            <v-col
                v-for="item in items"
                :key="item.blockId"
                cols="12"
                md="6"
                lg="6"
                class="ma-0">
              <v-hover v-slot="{ hover }">
                <v-card
                    :id="item.blockId"
                    v-test="{ btn: item.blockId }"
                    :to="item.route"
                    :color="hover
                      ? 'blue-grey darken-2'
                      : 'active'"
                    :elevation="hover ? 12 : 2"
                    class="d-col align-start reg-nav-card mx-1 my-1 ">
                  <v-card-text class=" mt-12 text-center ">
                    <v-row :class="`${hover ? 'invert' : ''} subtitle-1 font-weight-bold`">
                      <v-col :cols="!!item.requestStatus?10:12">
                        {{ item.title }}
                      </v-col>
                      <v-col v-if="!!item.requestStatus" cols="1">
                        <icon-tip
                            :class="`${hover ? 'wite--text' : ''}`"
                            :icon-color="item.iconColor"
                            :tip="item.iconTip"
                            :icon="item.icon" />
                      </v-col>
                    </v-row>
                    <v-row :class="`${hover ? 'invert' : ''} subtitle-1 font-weight-medium`">
                      <v-col cols="12">
                        {{ item.description }}
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-card-text>

      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped>
    .invert {
        color: white
    }
    .reg-nav-card{
        min-height: 200px;
    }
</style>

<script>
  import IconTip from '@/components/reused/ui/IconTip.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { REQUEST_STATUSES, ORG_REQUEST_STATUSES } from '@/constants//business'
  import { mapActions, mapState } from 'vuex'
  import { USER_PROFILE, ORGANIZATION_DRAFT } from '@/constants/store.js'

  export default {
    components: {
      IconTip,
      GeneralError
    },
    data () {
      return {
        isLoading: false
      }
    },
    computed: {
      ...mapState(USER_PROFILE.NAMESPACE, {
        userRequest: state => (state[USER_PROFILE.STATE.REQUEST] || { })
      }),
      ...mapState(ORGANIZATION_DRAFT.NAMESPACE, {
        organizationRequest: state => (state[ORGANIZATION_DRAFT.STATE.REQUEST] || { })
      }),
      items () {
        const orgStatus = this.organizationRequest.status
        const userStatus = this.userRequest.status
        const orgInfo = this.getIconParamsByCommonStatus(orgStatus) || {}
        const userInfo = this.getIconParamsByStatus(userStatus) || {}
        return [
          {
            blockId: 'toOrganizationRegistrationWizardBtn',
            route: `${this.urlRootPath}/user/registration/organization`,
            title: this.$t('Регистрация организации'),
            description: this.$t('Для проведения торгов и/или участия в торгах'),
            requestStatus: orgStatus,
            icon: orgInfo.icon,
            iconColor: orgInfo.iconColor,
            iconTip: orgInfo.iconTip
          },
          {
            blockId: 'toUserRegistrationWizardBtn',
            route: `${this.urlRootPath}/user/registration/profile`,
            title: this.$t('Регистрация Уполномоченного представителя'),
            description: this.$t('Регистрация УП возможна после регистрации организации.'),
            requestStatus: userStatus,
            icon: userInfo.icon,
            iconColor: userInfo.iconColor,
            iconTip: userInfo.iconTip
          }
        ]
      }
    },
    created () {
      const vm = this
      vm.clearStore().then(() => {
        vm.initialize()
      })
    },
    methods: {
      ...mapActions(USER_PROFILE.NAMESPACE, {
        getUserRegistrationRequestAction: USER_PROFILE.ACTIONS.GET_USER_REGISTRATION_REQUEST,
        clearUserRegistrationRequestAction: USER_PROFILE.ACTIONS.CLEAR_USER_REGISTRATION_REQUEST
      }),
      ...mapActions(ORGANIZATION_DRAFT.NAMESPACE, {
        getOrganizationRegistrationRequestAction: ORGANIZATION_DRAFT.ACTIONS.GET_ORGANIZATION_REGISTRATION_REQUEST,
        clearOrganizationRegistrationRequestAction: ORGANIZATION_DRAFT.ACTIONS.CLEAR_ORGANIZATION_REGISTRATION_REQUEST
      }),
      getIconParamsByStatus: function (status) {
        switch (status) {
        case REQUEST_STATUSES.APPROVED:
          return {
            icon: 'check_circle_outline',
            iconColor: 'success',
            iconTip: this.$t('Регистрация завершена')
          }
        case '':
        case REQUEST_STATUSES.CREATED:
          return {
            icon: 'add_circle_outline',
            iconColor: 'inactiveitem',
            iconTip: this.$t('Запрос не отправлен')
          }
        case REQUEST_STATUSES.REJECTED:
          return {
            icon: 'error_outline',
            iconColor: 'error',
            iconTip: this.$t('Запрос отклонен')
          }
        case REQUEST_STATUSES.INPROCESS:
          return {
            icon: 'query_builder',
            iconColor: 'primary',
            iconTip: this.$t('Ожидание обработки Организатором')
          }
        }
      },
      getIconParamsByCommonStatus: function (status) {
        switch (status) {
        case ORG_REQUEST_STATUSES.APPROVED:
          return {
            icon: 'check_circle_outline',
            iconColor: 'success',
            iconTip: this.$t('Регистрация завершена')
          }
        case '':
        case ORG_REQUEST_STATUSES.CREATED:
          return {
            icon: 'add_circle_outline',
            iconColor: 'blue-grey lighten-3',
            iconTip: this.$t('Запрос не отправлен')
          }
        case ORG_REQUEST_STATUSES.REJECTED:
          return {
            icon: 'error_outline',
            iconColor: 'error',
            iconTip: this.$t('Запрос отклонен Организатором')
          }
        case ORG_REQUEST_STATUSES.INPROCESS:
          return {
            icon: 'query_builder',
            iconColor: 'primary',
            iconTip: this.$t('Ожидание обработки Организатором')
          }
        }
      },
      clearStore: async function () {
        await Promise.all(
          [
            this.clearOrganizationRegistrationRequestAction(),
            this.clearUserRegistrationRequestAction()
          ])
      },
      initialize: async function () {
        this.isLoading = true
        try {
          await this.getCurrentUserInfo()
          if (this.isAdmin) {
            this.goToRoute(`${this.urlRootPath}/manage`)
          } else {
            await Promise.all([
              this.getOrganizationRegistrationRequestAction(),
              this.getUserRegistrationRequestAction()
            ])
          }

          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
